/**
 * Blog permalink redirect.
 * Redirects /blog and /blog/:slug to the home page Blog tab.
 *
 * @module pages/blogPost
 */

import { useEffect }            from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Redirects to /?tab=blog on mount.
 *
 * @returns {null}
 */
export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/?tab=blog${slug ? `&post=${slug}` : ''}`, { replace: true });
  }, [slug, navigate]);

  return null;
}
